<template>
  <div id="mycard" class="card">

    <WindowTitleBar title="Knitting QC Information" @loadData="loadData" @close_window="closeThis" >{{setTitle()}}</WindowTitleBar>

    <div class="card-body">

      <div class="row">

        <div class="col-md-2">
          <div class="form-group form-group-material ">
            <label class="control-label text-semibold">Shift</label>
            <select id="cmbShift" ref="cmbShift" class="form-control" autofocus="" v-if="qc"  v-model="qc.shift_id">
              <option value="2">Day</option>
              <option value="3">Night</option>
            </select>
          </div>
        </div>

        <div class="col-md-2">
          <div class="form-group form-group-material ">
            <label class="control-label text-semibold">Operator</label>
            <select class="form-control" v-if="qc" v-model="qc.emp_id">
              <option v-for="emp in emps" v-bind:value="emp.id">
                {{ emp.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-md-2">
        </div>

        <div class="col-md-5">
        </div>


        <div class="col-md-1">
          <div class="form-group form-group-material">
            <label class="control-label text-semibold">Date</label>
            <input type="date" class="form-control text-right" v-if="qc" v-model="qc.doc_date">
          </div>
        </div>
      </div>


      <div class="row">
        <div class="col-md-12">

          <!-- Basic layout-->
          <div class="card">


            <div class="card-body">

              <!--  Detail Table -->
              <div class="row">
                <div class="table-responsive">

                  <table id="mytable" class="table table-no-bordered">
                    <thead style="background-color: lightgrey">
                    <tr>
                      <th style="width: 100px;" >S.No</th>
                      <th>FabCode</th>
                      <th>#</th>
                      <th>Quality</th>
                      <th>Color</th>
                      <th style="text-align: right;">Weight</th>
                      <th style="text-align: right;">ஒத்தஊசி</th>
                      <th style="text-align: right;">பொடிஓட்டை</th>
                      <th style="text-align: right;">Damage</th>
                      <th style="width: 30px;">Action</th>
                    </tr>
                    </thead>

                    <tbody v-model="qc" v-for="(rcpt,index) in qc.list" >
                    <KnittingQcDetailRow :myindex="index" :myrow="rcpt" v-on:onrow_change="onrowchange" v-on:onRemoveRow="removeRow" ></KnittingQcDetailRow>
                    </tbody>

                    <tfoot>
                    <tr>
                      <td>
                        <button id="btnAddRow" type="button" class="btn border-success btn-flat btn-icon btn-rounded" @click="addRow">
                          <i class="icon-plus3"></i>
                        </button>
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td style="text-align: right;" class="font-weight-semibold">{{totalweight | weightFormat}}</td>
                      <td class="font-weight-semibold" style="text-align: right;">{{totalneedle }}</td>
                      <td class="font-weight-semibold" style="text-align: right;">{{totalhole}}</td>
                      <td class="font-weight-semibold" style="text-align: right;">{{totaldamage}}</td>
                      <td></td>
                    </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <!-- / Detail Table -->


            </div>
          </div>
          <!-- /basic layout -->

        </div>

      </div>

      <div class="row">

        <div class="col-md-3">
          <div class="form-group form-group-material">
            <label class="control-label text-semibold">Remarks</label>
            <textarea id="txtremarks" class="form-control" placeholder="Remarks"  v-if="qc" v-model="qc.remarks" > </textarea>
          </div>
        </div>


        <div class="col-md-6">
        </div>

        <div class="col-md-3 text-right">
          <button id="btnSave" type="button" class="btn bg-green-800 btn-raised active" @click="perform_save_action" >Save</button>
          <button type="button" id="btnclose" class="btn btn-default" data-dismiss="" @click="perform_clear_action" >Clear</button>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment-timezone'
import {userService} from '@/store/auth-header.js'
import { store } from '@/store/store.js'
import KnittingQcDetailRow from '@/components/core/KnittingQcDetailRow.vue'
import WindowTitleBar from '../../../components/core/WindowTitleBar'

export default {
  name: 'KnittingQcForm',
  store,
  components: {
    KnittingQcDetailRow,
    WindowTitleBar
  },
  props: {
    myqc: {
      type: Object,
      default: () => JSON.parse('{"id":0,"status":"Active","finyear":1,"doc_no":1,"doc_date":"2000-01-01","cmp_id":1,"shift_id":1,"mac_id":1,"emp_id":1,"needle_damages":0,"hole_damages":0,"other_damages":0,"weight":0,"trn_id":1,"remarks":"","shift":{"id":1,"status":"Active","name":""},"machine":{"id":1,"type":0,"name":"","status":"Active"},"employee":{"id":1,"code":"","status":"Active","name":"","design_id":1,"extrusion":false,"stentering":false,"warping":false,"designation":{"id":1,"status":"Active","name":"","min_wage":0}},"list":[]}')
    }
  },
  beforeMount () {
    this.qc = this.myqc;
    this.displayTotal();
  },
  data() {
    return {
      defects:[],
      emps:[],
      qc : JSON.parse('{"id":0,"status":"Active","finyear":1,"doc_no":1,"doc_date":"2000-01-01","cmp_id":1,"shift_id":1,"mac_id":1,"emp_id":1,"needle_damages":0,"hole_damages":0,"other_damages":0,"weight":0,"trn_id":1,"remarks":"","shift":{"id":1,"status":"Active","name":""},"machine":{"id":1,"type":0,"name":"","status":"Active"},"employee":{"id":1,"code":"","status":"Active","name":"","design_id":1,"extrusion":false,"stentering":false,"warping":false,"designation":{"id":1,"status":"Active","name":"","min_wage":0}},"list":[]}'),
      detail : JSON.parse('{"idx":0,"id":0,"status":"Active","finyear":1,"doc_no":0,"doc_date":"2000-01-01","cmp_id":1,"shift_id":1,"mac_id":1,"emp_id":1,"item_id":1,"qua_id":1,"col_id":1,"fab_weight":0,"fab_waste_weight":0,"yarn_waste_weight":0,"defects_count":0,"trn_id":1,"needle_damages":0,"hole_damages":0,"other_damages":0,"stentering_damages":0,"remarks":"","mtrs":0,"weight":0,"avg_weight":0,"shift":{"id":1,"status":"Active","name":""},"machine":{"id":1,"type":0,"name":"","status":"Active"},"employee":{"id":1,"code":"","status":"Active","name":"","design_id":1,"extrusion":false,"stentering":false,"warping":false,"designation":{"id":1,"status":"Active","name":"","min_wage":0}},"item":{"id":1,"status":"","type":"","name":"","group_id":1,"unit_id":1,"brand_id":1,"quality_id":1,"color_id":1,"weight":0,"min_qty":0,"max_qty":0,"group":{"id":1,"name":"","type":0,"status":"Active","hsn":"","nature":0,"unit_id":1,"gstrate":0,"itcrate":0,"unit":{"id":1,"type":0,"name":"Nos","status":"Active","digits":0}},"unit":{"id":1,"type":0,"name":"Nos","status":"Active","digits":0},"quality":{"id":1,"type":0,"name":"","status":"Active","weight":0,"colorcharts":[]},"color":{"id":1,"type":0,"name":"","status":"Active","weight":0,"chart":[]},"brand":{"id":1,"type":1,"name":"Primary","status":"Active"}},"quality":{"id":1,"type":0,"name":"","status":"Active","weight":0,"colorcharts":[]},"color":{"id":1,"type":0,"name":"","status":"Active","weight":0,"chart":[]}}'),
      mycard: {},
      totalweight: 0,
      totalneedle:0,
      totalhole:0,
      totaldamage:0,
    }
  },
  created(){
  },
  mounted(){
    const self = this;
    self.$data.mycard = $('#mycard');

    if (self.$data.qc.doc_date == '0001-01-01' || self.$data.qc.doc_date == '2000-01-01') {
      self.$data.qc.doc_date = moment().format('YYYY-MM-DD');
    }
    self.loadData();
    this.$refs.cmbShift.focus();
    $('#cmbShift').focus();
  },
  filters:{
    weightFormat (val){
      return val.toFixed(3);
    }
  },
  methods:{
    setTitle() {
      return this.qc.id == 0 ? "Knitting QC Creation" : "Doc No: " + this.qc.doc_no + "  Knitting QC Updation";
    },
    closeThis(){
      this.$emit('knitting_qc_window_closed');
      if(this.qc.id > 1){
        // this.$modal.hide('knitting_qc_window');
        this.qc = JSON.parse('{"id":0,"status":"Active","finyear":1,"doc_no":1,"doc_date":"2000-01-01","cmp_id":1,"shift_id":1,"mac_id":1,"emp_id":1,"needle_damages":0,"hole_damages":0,"other_damages":0,"weight":0,"trn_id":1,"remarks":"","shift":{"id":1,"status":"Active","name":""},"machine":{"id":1,"type":0,"name":"","status":"Active"},"employee":{"id":1,"code":"","status":"Active","name":"","design_id":1,"extrusion":false,"stentering":false,"warping":false,"designation":{"id":1,"status":"Active","name":"","min_wage":0}},"list":[]}');
      }else{
        this.$router.push("/")
      }
    },
    loadData(){
      this.loadEmps();
    },
    addRow(){
      const self = this;
      let receipt = {"idx":0, "id":0,"status":0,"type":0,"qc_code":0,"is_cr":"","finyear":0,"doc_no":0,"machine":{"id":0,"type":0,"nature":0,"name":"","p_name":""},"shift":{"id":0,"type":0,"name":""},"operator":{"id":0,"status":0,"emp_code":"","name":""},"date":"0001-01-01","color":{"id":0,"status":0,"name":""},"quality":{"id":0,"name":""},"fabric":{"id":0,"nature":0,"active":"","name":"","p_name":"","process":{"id":0,"name":"","nature":0,"p_name":"","s_name":"","ledger":{"id":0,"type":0,"name":"","alias":"","group":{"id":0,"status":0,"type":0,"name":"","alias":""}},"print_data":""},"group":{"id":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":0,"name":"","digits":0},"subunit":{"id":0,"name":"","digits":0},"conv_fact":0,"has_bom":false},"design":{"id":0,"name":"","p_name":""},"color":{"id":0,"status":0,"name":"","p_name":""},"quality":{"id":0,"name":"","p_name":""},"category":{"id":0,"name":"","p_name":""},"brand":{"id":0,"name":"","print_name":""},"style":{"id":0,"name":"","p_name":""},"size":{"id":0,"nature":0,"name":"","p_name":"","width":0,"length":0,"height":0,"unit":0},"unit":{"id":0,"name":"","digits":0}},"fab_wgt":0,"yarn_waste":{"id":0,"nature":0,"active":"","ledger_group":{"id":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false},"name":"","p_name":"","process":{"id":0,"name":"","nature":0,"p_name":"","s_name":"","ledger":{"id":0,"type":0,"name":"","alias":"","group":{"id":0,"status":0,"type":0,"name":"","alias":""}},"print_data":""},"group":{"id":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":0,"name":"","digits":0},"subunit":{"id":0,"name":"","digits":0},"conv_fact":0,"has_bom":false},"design":{"id":0,"name":"","p_name":""},"color":{"id":0,"status":0,"name":"","p_name":""},"quality":{"id":0,"name":"","p_name":""},"category":{"id":0,"name":"","p_name":""},"brand":{"id":0,"name":"","print_name":""},"style":{"id":0,"name":"","p_name":""},"size":{"id":0,"nature":0,"name":"","p_name":"","width":0,"length":0,"height":0,"unit":0},"unit":{"id":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"yarn_waste_wgt":0,"fab_waste":{"id":0,"nature":0,"active":"","ledger_group":{"id":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false},"name":"","p_name":"","process":{"id":0,"name":"","nature":0,"p_name":"","s_name":"","ledger":{"id":0,"type":0,"name":"","alias":"","group":{"id":0,"status":0,"type":0,"name":"","alias":""}},"print_data":""},"group":{"id":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":0,"name":"","digits":0},"subunit":{"id":0,"name":"","digits":0},"conv_fact":0,"has_bom":false},"design":{"id":0,"name":"","p_name":""},"color":{"id":0,"status":0,"name":"","p_name":""},"quality":{"id":0,"name":"","p_name":""},"category":{"id":0,"name":"","p_name":""},"brand":{"id":0,"name":"","print_name":""},"style":{"id":0,"name":"","p_name":""},"size":{"id":0,"nature":0,"name":"","p_name":"","width":0,"length":0,"height":0,"unit":0},"unit":{"id":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"fab_waste_wgt":0,"defects_count":0,"remarks":"","needle_damages":0,"hole_damages":0,"other_damages":0};
      self.$data.qc.list.push(receipt);

      setTimeout(function(){
        $("tbody>tr").last().find("td:eq(1) input").focus();
      }, 99);
    },
    onrowchange(rowIndex, colIndex, val) {
      const self = this;
      switch (colIndex) {
        case 1:
          self.$data.qc.list[rowIndex] = val;
          break;
        case 6:
          self.$data.qc.list[rowIndex].needle_damages = parseInt(val);
          break;
        case 7:
          self.$data.qc.list[rowIndex].hole_damages = parseInt(val);
          break;
        case 8:
          self.$data.qc.list[rowIndex].other_damages = parseInt(val);
          break;
      }
      self.displayTotal();
    },
    removeRow(index){
      if (index > -1) {
        this.$data.qc.list.splice(index, 1);
        this.displayTotal();
      }
    },
    displayTotal(){
      const self = this;
      self.totalweight = 0;
      self.totalneedle = 0;
      self.totalhole = 0;
      self.totaldamage= 0;

      self.$data.qc.list.forEach(  (rcpt) =>{
        self.totalweight += rcpt.fabric.fab_weight;
        self.totalneedle += rcpt.needle_damages;
        self.totalhole += rcpt.hole_damages;
        self.totaldamage += rcpt.other_damages;
      });

    },
    loadEmps(){

      const self = this;

      const requestOptions = {
        method: 'GET',
        mode:"cors",
        headers: userService.authHeader()
      };

      self.$data.emps = []
      fetch(`${process.env.VUE_APP_ROOT_API}api/employees`,requestOptions).then(userService.handleResponse).then(function (resp) {
        if (resp.ok){
          if(  !_.isNull(resp.data)){
            self.$data.emps = resp.data;
          }
        }else{
          swal (  {title:"Oops" ,  text: resp.msg,  type: "error", timer:3000});
        }
      }).catch(function (err) {
        swal (  {title:"Oops" ,  text: err.toString(),  type: "error", timer:3000});
      });
    },
    loadFabric(code, idx){
      if(code < 1) {
        return;
      }

      const self = this;

      const requestOptions = {
        method: 'GET',
        mode:"cors",
        headers: userService.authHeader()
      };

      $('#mycard').block({
        message: '<i class="icon-spinner2 spinner"></i>',
        overlayCSS: {
          backgroundColor: '#fff',
          opacity: 0.8,
          cursor: 'wait',
          'box-shadow': '0 0 0 1px #ddd'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'none'
        }
      });

      // self.$data.qc.list[idx] = {"id":0,"status":0,"type":0,"qc_code":0,"is_cr":"","finyear":0,"doc_no":0,"machine":{"id":0,"type":0,"nature":0,"name":"","p_name":""},"shift":{"id":0,"type":0,"name":""},"operator":{"id":0,"status":0,"emp_code":"","name":""},"date":"0001-01-01","color":{"id":0,"status":0,"name":""},"quality":{"id":0,"name":""},"fabric":{"id":0,"nature":0,"active":"","name":"","p_name":"","process":{"id":0,"name":"","nature":0,"p_name":"","s_name":"","ledger":{"id":0,"type":0,"name":"","alias":"","group":{"id":0,"status":0,"type":0,"name":"","alias":""}},"print_data":""},"group":{"id":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":0,"name":"","digits":0},"subunit":{"id":0,"name":"","digits":0},"conv_fact":0,"has_bom":false},"design":{"id":0,"name":"","p_name":""},"color":{"id":0,"status":0,"name":"","p_name":""},"quality":{"id":0,"name":"","p_name":""},"category":{"id":0,"name":"","p_name":""},"brand":{"id":0,"name":"","print_name":""},"style":{"id":0,"name":"","p_name":""},"size":{"id":0,"nature":0,"name":"","p_name":"","width":0,"length":0,"height":0,"unit":0},"unit":{"id":0,"name":"","digits":0}},"fab_wgt":0,"yarn_waste":{"id":0,"nature":0,"active":"","ledger_group":{"id":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false},"name":"","p_name":"","process":{"id":0,"name":"","nature":0,"p_name":"","s_name":"","ledger":{"id":0,"type":0,"name":"","alias":"","group":{"id":0,"status":0,"type":0,"name":"","alias":""}},"print_data":""},"group":{"id":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":0,"name":"","digits":0},"subunit":{"id":0,"name":"","digits":0},"conv_fact":0,"has_bom":false},"design":{"id":0,"name":"","p_name":""},"color":{"id":0,"status":0,"name":"","p_name":""},"quality":{"id":0,"name":"","p_name":""},"category":{"id":0,"name":"","p_name":""},"brand":{"id":0,"name":"","print_name":""},"style":{"id":0,"name":"","p_name":""},"size":{"id":0,"nature":0,"name":"","p_name":"","width":0,"length":0,"height":0,"unit":0},"unit":{"id":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"yarn_waste_wgt":0,"fab_waste":{"id":0,"nature":0,"active":"","ledger_group":{"id":0,"status":0,"type":0,"name":"","alias":"","print_name":"","parent_code":0,"nature":0,"affect_profit":false,"behave_like_sub_ledger":false,"net_cr_dr_balance":false,"used_for_calculation":false},"name":"","p_name":"","process":{"id":0,"name":"","nature":0,"p_name":"","s_name":"","ledger":{"id":0,"type":0,"name":"","alias":"","group":{"id":0,"status":0,"type":0,"name":"","alias":""}},"print_data":""},"group":{"id":0,"type":0,"nature":0,"name":"","p_name":"","hsn":"","gstrate":0,"itcrate":0,"unit":{"id":0,"name":"","digits":0},"subunit":{"id":0,"name":"","digits":0},"conv_fact":0,"has_bom":false},"design":{"id":0,"name":"","p_name":""},"color":{"id":0,"status":0,"name":"","p_name":""},"quality":{"id":0,"name":"","p_name":""},"category":{"id":0,"name":"","p_name":""},"brand":{"id":0,"name":"","print_name":""},"style":{"id":0,"name":"","p_name":""},"size":{"id":0,"nature":0,"name":"","p_name":"","width":0,"length":0,"height":0,"unit":0},"unit":{"id":0,"name":"","digits":0},"rate":0,"min_qty":0,"max_qty":0,"wgt":0},"fab_waste_wgt":0,"defects_count":0,"remarks":"","needle_damages":0,"hole_damages":0,"other_damages":0};

      fetch(`${process.env.VUE_APP_ROOT_API}api/knitting/receipt/${code}`,requestOptions).then(userService.handleResponse).then(function (resp) {
        if(resp.ok) {
          if(!_.isNull(resp.data)){
            self.$data.detail = resp.data;
            self.$data.qc.list[idx] = self.$data.detail;
          }
        } else {
          swal ( { title: "Oops!" ,  text: resp.msg, type:  "error", timer:3000} );
        }
      }).catch(function (err) {
        swal ( { title: "Oh noes!" ,  text: err.toString(), type:  "error", timer:3000} );
      }).finally(function () {
        $('#mycard').unblock();
      });
    },
    parseErrors(errorInput) {
      let errors = {};

      // If input is a string, try parsing it
      if (typeof errorInput === 'string') {
        try {
          errors = JSON.parse(errorInput);
        } catch (e) {
          // It's a plain string, return as-is
          return errorInput;
        }
      } else if (typeof errorInput === 'object' && errorInput !== null) {
        errors = errorInput;
      } else {
        return 'Unknown error format';
      }

      // Now format like before
      return Object.entries(errors)
        .map(([field, messages]) => {
          const label = field.replace(/\.\d+\./g, ' → ').replace(/\./g, ' ');
          // return `${messages.join(', ')}`;
          return `<b>${label}</b>: ${messages.join(', ')}`;
        })
        .join('<br>');
    },
    perform_save_action(){
      const self = this;

      self.$data.qc.status = "Active";
      self.$data.qc.cmp_id = self.$store.state.user.company.id;

      self.qc.finyear = store.state.user.finyear;
      self.qc.emp_id = parseInt(self.$data.qc.emp_id);
      self.qc.shift_id = parseInt(self.$data.qc.shift_id);

      let myvoucher =  JSON.parse(JSON.stringify(self.$data.qc));

      myvoucher.id = self.$data.qc.id;
      myvoucher.finyear = self.$data.qc.finyear;
      myvoucher.emp_id = self.$data.qc.emp_id;
      myvoucher.shift_id = self.$data.qc.shift_id;
      myvoucher.doc_date = moment(self.$data.qc.doc_date).format('YYYY-MM-DD');
      myvoucher.needle_damages = 0;
      myvoucher.hole_damages = 0;
      myvoucher.other_damages = 0;
      myvoucher.weight = 0;
      myvoucher.list = [];

      myvoucher.finyear = store.state.user.finyear;
      myvoucher.status = "Active";
      myvoucher.cmp_id = self.$store.state.user.company.id;

      self.qc.list.forEach(function (fab) {
        fab.doc_date = moment(fab.doc_date).format('YYYY-MM-DD');
        fab.id = parseInt(fab.id);
        fab.needle_damages = parseInt(fab.needle_damages);
        fab.hole_damages = parseInt(fab.hole_damages);
        fab.other_damages = parseInt(fab.other_damages);
        myvoucher.list.push(fab);

        myvoucher.needle_damages += parseInt(fab.needle_damages);
        myvoucher.hole_damages += parseInt(fab.hole_damages);
        myvoucher.other_damages += parseInt(fab.other_damages);
        myvoucher.weight += fab.fab_weight;
      });

      if(myvoucher.emp_id < 1) {
        alert("Invalid Operator");
        return
      }else if(myvoucher.shift_id < 1){
        alert("Invalid Shift");
        return
      }else if(myvoucher.list.length < 1){
        alert("Invalid Fabrics");
        return
      }


      const requestOptions = {
        method:  (self.$data.qc.id == 0 ? 'POST' : 'PUT'),
        mode:"cors",
        headers: userService.authHeader(),
        body: JSON.stringify(myvoucher)
      };


      $('#mycard').block({
        message: '<i class="icon-spinner2 spinner"></i>',
        overlayCSS: {
          backgroundColor: '#fff',
          opacity: 0.8,
          cursor: 'wait',
          'box-shadow': '0 0 0 1px #ddd'
        },
        css: {
          border: 0,
          padding: 0,
          backgroundColor: 'none'
        }
      });

      fetch(`${process.env.VUE_APP_ROOT_API}api/knitting/qc`,requestOptions).then(userService.handleResponse).then(function (resp) {
        if(resp.ok) {

          self.$data.qc = JSON.parse('{"id":0,"status":"Active","finyear":1,"doc_no":1,"doc_date":"2000-01-01","cmp_id":1,"shift_id":1,"mac_id":1,"emp_id":1,"needle_damages":0,"hole_damages":0,"other_damages":0,"weight":0,"trn_id":1,"remarks":"","shift":{"id":1,"status":"Active","name":""},"machine":{"id":1,"type":0,"name":"","status":"Active"},"employee":{"id":1,"code":"","status":"Active","name":"","design_id":1,"extrusion":false,"stentering":false,"warping":false,"designation":{"id":1,"status":"Active","name":"","min_wage":0}},"list":[]}');
          self.$data.qc.doc_date = moment().format('YYYY-MM-DD');
          self.totalweight = 0;
          self.totalneedle = 0;
          self.totalhole = 0;
          self.totaldamage= 0;

          self.$emit('knitting_qc_saved');

          swal ( { title: "Success!" ,  text: resp.msg, type:  "success", timer:3000, onClose: () => {
              $('#cmbshift').focus();
            }});


        } else {
          swal ( { title: "Oops!" ,  html: self.parseErrors(resp.msg), type:  "error"} );
        }
      }).catch(function (err) {
        swal ( { title: "Oh noes!" ,  text: err.toString() , type:  "error"} );
      }).finally(function () {
        $('#mycard').unblock();
      });

    },
    perform_clear_action(){
      const self = this;

      self.$data.qc = JSON.parse('{"id":0,"status":"Active","finyear":1,"doc_no":1,"doc_date":"2000-01-01","cmp_id":1,"shift_id":1,"mac_id":1,"emp_id":1,"needle_damages":0,"hole_damages":0,"other_damages":0,"weight":0,"trn_id":1,"remarks":"","shift":{"id":1,"status":"Active","name":""},"machine":{"id":1,"type":0,"name":"","status":"Active"},"employee":{"id":1,"code":"","status":"Active","name":"","design_id":1,"extrusion":false,"stentering":false,"warping":false,"designation":{"id":1,"status":"Active","name":"","min_wage":0}},"list":[]}');
      self.$data.qc.doc_date = moment().format('YYYY-MM-DD');

      self.totalweight = 0;
      self.totalneedle = 0;
      self.totalhole = 0;
      self.totaldamage= 0;

      $('#cmbShift').focus();

    },
  }
}
</script>

<style scoped>
input:focus {
  background: #feff00;
}

textarea:focus {
  background: #feff00;
}

select:focus {
  background: #feff00;
}

button:focus {
  background: #feff00;
  color: #0a0a0a!important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

input[type="date"]::-webkit-inner-spin-button,
input[type="date"]::-webkit-calendar-picker-indicator {
  display: none;
  -webkit-appearance: none;
}
</style>
